import { Panel } from '@/components/Panel';

export function ForbiddenPage() {
  return <Panel className="p-12 text-center text-slate-500">Vous n'avez pas accès à cette page.</Panel>;
}
